import { background } from 'assets/backgrounds'
import { useAreaFromSlug } from 'hooks/useAreaFromSlug'
import { useParams } from 'react-router-dom'
import {
  Banner,
  Contact,
  GetAdvice,
  LatestMedia,
  LegalFields,
  OurApproach,
  OurApproachSolutionProcess,
} from './components'

const LegalField = () => {
  const params = useParams()
  const area = useAreaFromSlug(params?.area)

  return (
    <>
      <div
        className='bg-cover bg-center'
        style={{
          backgroundImage: `url(${background.discoverLawTemplate._01})`,
        }}
      >
        <Banner title={area?.master_term} imgSrc={area?.banner_image} />
        <LegalFields area={area?.master_term} />
      </div>
      <LatestMedia area={area?.master_term} />
      <OurApproach />
      <OurApproachSolutionProcess />
      <GetAdvice id={area?.id} idName='area_id' />
      <Contact />
    </>
  )
}

export default LegalField
